import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag servera alkohol på personalfest utan extra tillstånd?";
const SHORT_ANSWER = "Ja, om personalfesten hålls i ditt eget serveringsställe inom ramen för befintligt tillstånd – då gäller samma regler som ordinarie drift.";

export const Route = createFileRoute("/fraga/vad-galler-vid-personalfest")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag servera alkohol på personalfest utan ex…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Hålls personalfesten på extern plats krävs ett tillfälligt tillstånd till slutet sällskap eller cateringtillstånd. Glöm inte att åldersgräns och berusningsregler gäller även för personal."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd för fest" }}
      related={[{"to": "/fraga/far-personalen-dricka-pa-jobbet", "label": "Får personalen dricka alkohol under arbetspasset?"}, {"to": "/fraga/vad-ar-ordningsvakter-och-nar-kravs-de", "label": "När krävs ordningsvakter på en restaurang?"}, {"to": "/fraga/vilka-anteckningar-maste-jag-fora", "label": "Vilka anteckningar måste jag föra i verksamheten?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag servera alkohol på personalfest utan extra tillst…" },
      { name: "description", content: "Ja, om personalfesten hålls i ditt eget serveringsställe inom ramen för befintligt tillstånd – då gäller samma regler som ordinarie drift." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-vid-personalfest" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-vid-personalfest" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-vid-personalfest",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag servera alkohol på personalfest utan ex…", url: "https://alkoholprovet.se/fraga/vad-galler-vid-personalfest" },
      ]),
    ],
  }),
});
